import { useState } from "react";
import { Link } from "react-router-dom";

import { STORAGE_KEY } from "../../consent/cookieConsent";

import "./CookieConsent.css";

function CookieConsent({ onAccept }) {
  const [acknowledged, setAcknowledged] = useState(() => {
    try {
      return Boolean(window.localStorage.getItem(STORAGE_KEY));
    } catch {
      return false;
    }
  });

  const accept = () => {
    try {
      window.localStorage.setItem(STORAGE_KEY, "accepted");
    } catch {
      /* ignore */
    }
    setAcknowledged(true);
    onAccept?.();
  };

  if (acknowledged) return null;

  return (
    <div
      className="CookieConsent"
      role="dialog"
      aria-modal="false"
      aria-label="Cookie notice"
    >
      <div className="CookieConsent-inner">
        <p className="CookieConsent-text">
          We use cookies and similar technologies to run this site, remember
          preferences, and understand traffic. By continuing, you agree to our
          use of these technologies. Read our{" "}
          <span>
            <Link to="/privacy-policy" className="CookieConsent-link">
              Privacy Policy
            </Link>
          </span>
          for more.
        </p>
        <button
          type="button"
          className="btn-3 CookieConsent-accept"
          onClick={accept}
        >
          Accept
        </button>
      </div>
    </div>
  );
}

export default CookieConsent;
